
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { DietaryRestriction } from "@/types/dietary";

interface DietarySelectorDropdownProps {
  selectedDiet: DietaryRestriction | null;
  relevantDiets: DietaryRestriction[];
  onDietSelect: (diet: DietaryRestriction | null) => void;
  allowNoDiet?: boolean;
}

export const DietarySelectorDropdown = ({
  selectedDiet,
  relevantDiets,
  onDietSelect,
  allowNoDiet = false,
}: DietarySelectorDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="w-full justify-between">
          <span>{selectedDiet ? selectedDiet.name : "Select Dietary Need"}</span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-full min-w-[200px] bg-white">
        {allowNoDiet && (
          <DropdownMenuItem
            onClick={() => onDietSelect(null)}
            className="cursor-pointer"
          >
            No Special Diet
          </DropdownMenuItem>
        )}
        {relevantDiets.map((diet) => (
          <DropdownMenuItem
            key={diet.name}
            onClick={() => onDietSelect(diet)}
            className="cursor-pointer"
          >
            {diet.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
